import { getUserFields } from "components/user/config";
import { getItemsFromCollection } from "directus/src/operations";

export async function fetchAverageFeedbackForCurrentUser({
  quadId,
  employeeId,
}) {
  try {
    const query = {
      fields: [
        "employee.id",
        "employee.user.role.name",
        "employee.department",
        "teamwork",
        "communication",
        "quality_and_technical_skills",
        "feedback",
        "time_management",
        "analytical_thinking",
        "work_relationships",
        "decision_making",
        "process_thinking",
        "mentoring",
        "business_acumen_and_strategy",
      ],
      filter: {
        employee: { _eq: employeeId },
        quadrimester: { _eq: quadId },
      },
    };
    const response = await getItemsFromCollection(
      "average_performance_review",
      query,
    );

    return response?.[0] || {};
  } catch (error) {
    console.log(error);
    return {};
  }
}

const METRIC_FIELDS = [
  "teamwork",
  "communication",
  "quality_and_technical_skills",
  "feedback",
  "time_management",
  "analytical_thinking",
  "work_relationships",
  "decision_making",
  "process_thinking",
  "mentoring",
  "business_acumen_and_strategy",
];

export async function fetchGradeAverage({ quadrimesterId, grade, employeeId }) {
  try {
    const query = {
      filter: {
        _and: [
          { employee: { _neq: employeeId } },
          { employee: { grade: { id: { _eq: grade } } } },
        ],
        quadrimester: { _eq: quadrimesterId },
      },
      aggregate: {
        avg: METRIC_FIELDS,
      },
    };
    const res = await getItemsFromCollection(
      "average_performance_review",
      query,
    );

    return res?.[0]?.avg || {};
  } catch (error) {
    console.log(error);
    return {};
  }
}

export async function fetchDepartmentAverage({
  quadrimesterId,
  department,
  employeeId,
}) {
  try {
    const query = {
      filter: {
        _and: [
          { employee: { _neq: employeeId } },
          { employee: { department: { name: { _eq: department } } } },
        ],
        quadrimester: { _eq: quadrimesterId },
      },
      aggregate: {
        avg: METRIC_FIELDS,
      },
    };
    const res = await getItemsFromCollection(
      "average_performance_review",
      query,
    );
    return res?.[0]?.avg || {};
  } catch (error) {
    console.log(error);
    return {};
  }
}

export async function fetchSelfReviewScores({
  quadrimesterId,
  employeeId = "$CURRENT_USER",
}) {
  try {
    const query = {
      fields: [...METRIC_FIELDS, getUserFields("employee")],
      filter: {
        quadrimester: { _eq: quadrimesterId },
        reviewee: { _eq: employeeId },
        reviewer: { _eq: employeeId },
      },
      limit: 1,
    };

    const res = await getItemsFromCollection("performance_review", query);

    return res?.[0] || {};
  } catch (error) {
    console.log(error);
    return {};
  }
}
